/**
 * Announcement Bar — close button sets cookie, hides bar
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'aykah_announcement_closed';
  var bar = document.getElementById('announcement-bar');
  var btn = document.getElementById('announcement-close');

  if (!bar || !btn) return;

  // Check if already dismissed
  if (document.cookie.indexOf(COOKIE_NAME + '=1') !== -1) {
    bar.style.display = 'none';
    return;
  }

  btn.addEventListener('click', function () {
    bar.style.transition = 'height 0.3s ease, opacity 0.3s ease';
    bar.style.height = '0';
    bar.style.opacity = '0';
    bar.style.overflow = 'hidden';

    // Set cookie for 7 days
    var d = new Date();
    d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_NAME + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';

    setTimeout(function () {
      bar.style.display = 'none';
    }, 300);
  });
})();
